import { useEffect, useState } from 'react';
import { Host } from '../Host';


export interface StreamedQueryConfig {
    method: string;
    path: string;
    body?: any;
}

// private decoder = new TextDecoder('utf-8');
// private buffer = '';

// public push(value: Uint8Array) {

//     const chunk = this.decoder.decode(value, { stream: true });
//     console.log(chunk);

const fetchStreamed = async (config: StreamedQueryConfig, onRead: (value: Uint8Array) => void, onComplete?: () => void) => {

    const url = `${Host.apiUrl}${config.path}`;

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(config.body)
    });

    // Log the status for debugging
    console.log('Response status:', response.status);

    // Proceed with reading the stream even if status is not ok
    const reader = response.body.getReader();

    while (true) {
        const { done, value } = await reader.read();

        if (done) {
            console.log('Stream complete');
            onComplete?.();
            break;
        }

        onRead(value);
    }
};

const processItemsList = (callback: (item: any) => void) => {

    const state = {
        active: false,
        depth: 0,
        buffer: '',
    };

    const consumeNormal = (ch: string) => {
        if (ch === ',' && state.depth === 0) {
            return;
        }
        // Consume
        state.buffer += ch;
        // If {, increment depth
        if (ch === '{') {
            state.depth++;
        }
        // If }, decrement depth
        else if (ch === '}') {
            state.depth--;
            // If depth is 0, we have a complete item
            if (state.depth === 0) {
                console.log(state.buffer);
                const item = JSON.parse(state.buffer);
                callback(item);
                state.buffer = '';
            }
        }
    };

    const consumeInitial = (ch: string) => {
        // Basically wait until the first [ key has gone, then we are active
        if (ch === '[') {
            state.active = true;
        }
    };

    return (token: string) => {
        for (const ch of token) {
            if (!state.active) {
                consumeInitial(ch);
            }
            else {
                consumeNormal(ch);
            }
        }
    };
};

// class LanguageModelItemStream extends EventEmitter<{ 'item': [any] }> {

//     private active = false;
//     private depth = 0;
//     private buffer = '';

//     public next(token: string) {
//         for (const ch of token) {
//             if (this.active) {
//                 this.consumeNormal(ch);
//             }
//             else {
//                 this.consumePreActivation(ch);
//             }
//         }
//     }


// }

export const useStreamedTextQuery = <T extends unknown>(path: string) => {

    const [text, setText] = useState<string>('');
    const [done, setDone] = useState<boolean>(false);
    const [params, setParams] = useState<T>(null);

    useEffect(() => {
        if (!params) return;

        const decoder = new TextDecoder('utf-8');
        const config = {
            method: 'POST',
            path,
            body: params,
        };

        fetchStreamed(
            config,
            (value) => {
                const str = decoder.decode(value, { stream: true });
                setText(x => x + str);
            },
            () => setDone(true)
        );

    }, [path, params]);

    return [text, setParams, done] as const;
};

export const useStreamedListQuery = <T extends unknown>(path: string) => {

    const [items, setItems] = useState<any[]>([]);
    const [params, setParams] = useState<T>(null);

    useEffect(() => {
        console.log(params);
        if (!params) return;

        const decoder = new TextDecoder('utf-8');
        const config = {
            method: 'POST',
            path,
            body: params,
        };

        const pipe = processItemsList(item => {
            setItems(x => [...x, item]);
        });

        fetchStreamed(config, (value) => {
            const str = decoder.decode(value, { stream: true });
            pipe(str);
        });

    }, [path, params]);

    return [items, setParams] as const;

};
